module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab1E"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版物中文名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publication",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publication),
      callback: function($$v) {
        _vm.$set(_vm.params, "publication", $$v)
      },
      expression: "params.publication"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版物外文名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publicationEnglish",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publicationEnglish),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationEnglish", $$v)
      },
      expression: "params.publicationEnglish"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("类别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.category),
      callback: function($$v) {
        _vm.$set(_vm.params, "category", $$v)
      },
      expression: "params.category"
    }
  }, _vm._l((_vm.dicDats['C026']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("文种：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "recordType",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.recordType),
      callback: function($$v) {
        _vm.$set(_vm.params, "recordType", $$v)
      },
      expression: "params.recordType"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("刊期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "periodicals",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.periodicals),
      callback: function($$v) {
        _vm.$set(_vm.params, "periodicals", $$v)
      },
      expression: "params.periodicals"
    }
  }, _vm._l((_vm.dicDats['C014']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("刊号（CN）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cn",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.cn),
      callback: function($$v) {
        _vm.$set(_vm.params, "cn", $$v)
      },
      expression: "params.cn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("国际刊号（ISSN）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "issn",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.issn),
      callback: function($$v) {
        _vm.$set(_vm.params, "issn", $$v)
      },
      expression: "params.issn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("批准时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "approvalTime",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "value-format": "yyyy-MM-dd",
      "size": "small"
    },
    model: {
      value: (_vm.params.approvalTime),
      callback: function($$v) {
        _vm.$set(_vm.params, "approvalTime", $$v)
      },
      expression: "params.approvalTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("批复文件：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [(_vm.params.applyFileId) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.filesDown(_vm.params.applyFileId)
      }
    }
  }, [_vm._v("\n              下载\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.params.applyFileId) ? _c('span', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "size": "mini",
      "type": "danger"
    }
  }, [_vm._v("\n              未上传\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("媒体形态：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "mediaForm",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.mediaForm),
      callback: function($$v) {
        _vm.$set(_vm.params, "mediaForm", $$v)
      },
      expression: "params.mediaForm"
    }
  }, _vm._l((_vm.dicDats['C025']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否缴送样本：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isSampleDelivery",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.isSampleDelivery),
      callback: function($$v) {
        _vm.$set(_vm.params, "isSampleDelivery", $$v)
      },
      expression: "params.isSampleDelivery"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publicationScope",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publicationScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationScope", $$v)
      },
      expression: "params.publicationScope"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("发行范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "issueScope",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.issueScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "issueScope", $$v)
      },
      expression: "params.issueScope"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("读者对象：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "readers",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.readers),
      callback: function($$v) {
        _vm.$set(_vm.params, "readers", $$v)
      },
      expression: "params.readers"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("出版物基本信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-297c8f0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/ssBlock/forEdit/ssTab1.vue
// module id = 1696
// module chunks = 1